import { render, staticRenderFns } from "./employees-edit.vue?vue&type=template&id=2432b618&scoped=true&"
import script from "./employees-edit.vue?vue&type=script&lang=ts&"
export * from "./employees-edit.vue?vue&type=script&lang=ts&"
import style0 from "./employees-edit.vue?vue&type=style&index=0&id=2432b618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2432b618",
  null
  
)

export default component.exports